import React from 'react';
import { Table, Button } from '../common';
import OnPremPORequestObject from '../../models/entities/OnPremPORequestObject';
import ProgressBarSmall from '../OnPremPORequestObjects/components/ProgressBarSmall';
import { useNavigate } from 'react-router-dom';
import './ApprovalsPORsTableRow.css';

interface ApprovalsOnPremObjectsTableRowProps {
    por: OnPremPORequestObject;
}

const ApprovalsOnPremObjectsTableRow = ({ por }: ApprovalsOnPremObjectsTableRowProps) => {
    const navigate = useNavigate();
    const handleViewDetails = () => {
        navigate(`/onPremPortOpeningObjects/${por.id}`);
    };
    
    return (
        <Table.Row>
            <Table.Cell>
                #{por.id}
            </Table.Cell>
            <Table.Cell>
                {por.type?.name?.toString() || 'N/A'}
            </Table.Cell>
            <Table.Cell className='em-u-text-align-center center-align'>
                <ProgressBarSmall workflowState={por.onPremWorkflowInstance.currentWorkflowInstanceState.onPremWorkflowState} />
            </Table.Cell>
            <Table.Cell className='em-u-text-align-center'>
                <Button style={{ width: 120, height: 34 }} onClick={handleViewDetails} variant="primary">
                    See Details
                </Button>
            </Table.Cell>
        </Table.Row>
    );
}

export default ApprovalsOnPremObjectsTableRow;